var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ubo"},[(!_vm.isUserLogged)?_c('div',[_c('h2',[_vm._v("Sign In below to claim your birthday offer.")])]):_c('div',[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.setResponseTitle()))]),_c('p',[_c('strong',{domProps:{"innerHTML":_vm._s(_vm.response.message)}})])])]),(!_vm.isUserLogged)?_c('SignInRegister'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }